@if (isValidRequest()) { @if (pdfRequestData(); as pdfRequestData) {
<ng-container>
	<div class="pad-left-md pad-right-md pad-top-sm">
		<div libFlexRow [libFlexRowGap]="'16px'">
			@if (brandLogoImage(); as brandLogoImage){
			<div libFlexColumn [libFlexSize]="'50px'">
				<lib-image [image]="brandLogoImage" [imageSize]="'50px'" [alt]="'Logo'"></lib-image>
			</div>
			}
			<div libFlexColumn libFlexFill>
				<h3>{{ appName() }}</h3>
				<div libText4>Created on {{ timestamp() }}</div>
			</div>
		</div>
	</div>

	<div class="pad-md">
		@if (workoutSharedData(); as workoutSharedData) {
		<div class="push-bottom">
			<h2>{{ workoutSharedData.data.workout?.system?.name }}</h2>
		</div>
		<mod-view-or-edit-workout [inputData]="workoutSharedData" [isPdfView]="true"></mod-view-or-edit-workout>
		} @if (dietSharedData(); as dietSharedData) {
		<div class="push-bottom">
			<h2>{{ dietSharedData.data.diet.system.name }}</h2>
		</div>
		<mod-view-or-edit-diet [inputData]="dietSharedData"></mod-view-or-edit-diet>
		} @if (trainingPlanSharedData(); as trainingPlanSharedData) {
		<div class="push-bottom">
			<div libFlexRow [libFlexRowGap]="'16px'">
				@if (trainingPlanSharedData.data.avatar) {
				<div libFlexColumn [libFlexSize]="'50px'">
					<lib-image
						[alt]="'Diet image'"
						[imageSize]="'50px'"
						[image]="trainingPlanSharedData.data.avatar"
					></lib-image>
				</div>
				}
				<div libFlexColumn>
					<h1>{{ trainingPlanSharedData.data.fullName }}</h1>
					<div libText3>Training plan</div>
				</div>
			</div>
		</div>
		<mod-client-training [inputData]="trainingPlanSharedData" [isPdfView]="true"></mod-client-training>
		} @if (dietPlanSharedData(); as dietPlanSharedData) {
		<div class="push-bottom">
			<div libFlexRow [libFlexRowGap]="'16px'">
				@if (dietPlanSharedData.data.avatar) {
				<div libFlexColumn [libFlexSize]="'50px'">
					<lib-image
						[alt]="'Diet image'"
						[imageSize]="'50px'"
						[image]="dietPlanSharedData.data.avatar"
					></lib-image>
				</div>
				}
				<div libFlexColumn>
					<h1>{{ dietPlanSharedData.data.fullName }}</h1>
					<div libText3>Diet plan</div>
				</div>
			</div>
		</div>
		<mod-client-diet [inputData]="dietPlanSharedData" [isPdfView]="true"></mod-client-diet>
		}
	</div>
</ng-container>
} } @else { Malformed PDF request }
